module.exports = new __parcel__URL__("delivery.ee8aaefd.png").toString();